module.exports = __webpack_public_path__ + "img/teeth-35.b5a4a60f.png";